<template>
  <!-- 버튼 시작 -->
  <div class="container">
    <v-row class="container-btns main-btns" align="center" justify="center" no-gutters dense>
      <v-col cols="12" class="container-btn main-btn" @click="setClipType('record')">
        <!-- <span class="material-icons-round" translate="no">{{ 'radio_button_checked' }}</span> -->
        <span class="empty_content_title main-btn">
          {{ 'Record Now' }}
        </span>
      </v-col>
      <!-- <v-col cols="2" class="container-btn" @click="expand = !expand" style="border-radius: 0 5px 5px 0">
        <span class="material-icons-round" translate="no">{{ expand ? 'expand_less' : 'expand_more' }}</span>
      </v-col> -->
      <v-col cols="12" class="text-show-more" @click="expand = !expand">
        <span>
          {{ expand ? 'show less option' : 'show more option' }}
        </span>
      </v-col>
    </v-row>
    <transition name="slide-fade">
      <v-row v-if="expand" class="container-btns sub-btns mt-1" align="center" justify="center" no-gutters dense>
        <v-col class="container-btn expand" no-gutters @click="setClipType('upload')">
          <span class="material-icons-round" translate="no">upload</span>
          <span class="empty_content_title">
            {{ $t('upload') }}
          </span>
        </v-col>
        <v-col class="container-btn expand ml-1" no-gutters @click="setClipType('text')">
          <span class="material-icons-round" translate="no">title</span>
          <span class="empty_content_title">
            {{ $t('text') }}
          </span>
        </v-col>
        <v-col
          class="container-btn expand ml-1"
          no-gutters
          @click="setClipType('embed')"
          @mouseover="hovered = key"
          @mouseleave="hovered = null"
        >
          <div>
            <img
              :src="hovered === key ? img.embedWhite : img.embed"
              alt="Embed_logo"
              width="22"
              style="position: relative; margin-top: -4px"
            />
          </div>
          <span class="empty_content_title">
            <!-- {{ $t('calendly') }} -->
            {{ 'Embed' }}
          </span>
        </v-col>
        <v-col class="container-btn expand ml-1" no-gutters @click="setClipType('poll')">
          <span class="material-icons-round" translate="no">how_to_vote</span>
          <span class="empty_content_title">
            {{ $t('poll') }}
          </span>
        </v-col>
        <!-- <v-col v-if="isShowFollowUp" class="container-btn" no-gutters justify="center" align="center" @click="willFollowUp">
      <span class="material-icons-round">reply</span>
      <span class="empty_content_title">
        {{ $t('willFollowUp') }}
      </span>
    </v-col> -->
        <v-col v-if="isShowFollowUp" class="container-btn expand ml-1" no-gutters @click="requestResponse">
          <span class="material-icons-round" translate="no">notifications_active</span>
          <span class="empty_content_title">
            {{ 'Request' }}
          </span>
        </v-col>
      </v-row>
    </transition>
    <guest-in v-if="guestInVisible" @close="closeGuestIn" :guestInVisible.sync="guestInVisible"></guest-in>
    <request-response-dialog
      v-if="requestVisible"
      @close="requestVisible = false"
      @finish="finishRequestDialog"
      :requestResponseVisible.sync="requestVisible"
    ></request-response-dialog>
    <require-upgrade-dialog
      v-if="upgradeVisible"
      @close="upgradeVisible = false"
      :requireUpgradeVisible.sync="upgradeVisible"
      :branch.sync="type"
    ></require-upgrade-dialog>
  </div>
</template>

<script>
import Toast from '@/views/meeting/component/Toast'
import { mapGetters } from 'vuex'
import RequestResponseDialog from '@/views/modal/RequestResponseDialog'
import RequireUpgradeDialog from '@/views/modal/RequireUpgradeDialog'
import GuestIn from '@/views/modal/GuestIn'

export default {
  components: {
    RequestResponseDialog,
    RequireUpgradeDialog,
    GuestIn,
    // DueDateDialog,
    // UploadVideo,
  },
  props: ['isShowFollowUp', 'grid', 'width'],
  data() {
    return {
      hovered: null,
      key: 'hoverd',
      requestVisible: false,
      upgradeVisible: false,
      guestInVisible: false,
      guestInActionType: '',
      img: {
        embed: require('@/assets/img/embed.png'),
        embedWhite: require('@/assets/img/embed-white.png'),
      },
      type: '',
      expand: false,
    }
  },
  methods: {
    closeGuestIn() {
      this.guestInVisible = false
      if (this.userInfo && this.userInfo !== null) {
        if (this.guestInActionType === 'request') {
          this.requestResponse()
        } else {
          this.setClipType(this.guestInActionType)
        }
      }
    },
    setClipType(type) {
      if ((type === 'record' || type === 'upload') && this.uploadVideoInfo && this.uploadVideoInfo['clip']) {
        // notify(this, 'Error', this.$t('clipUploadingError'), 'error')

        const content = {
          component: Toast,
          props: {
            msg: this.$t('clipUploadingError'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
        return
      }
      if (!this.userInfo || this.userInfo === null) {
        this.$store.dispatch('setSignInRedirectUrl', location.pathname)
        // this.$router.push({ name: 'SignIn' })
        this.guestInActionType = type
        this.guestInVisible = true
      } else {
        this.type = type
        if (!this.checkAvailableClip) {
          this.upgradeVisible = true
          return
        }
        // Free Type 일 경우 video upload 30개 이상인지 체크
        if (this.checkAvailableClip) {
          this.$store.dispatch('setIsRequestVideoType', type)
          this.$store.dispatch('setIsReplaceFollowUp', !this.isShowFollowUp)
        }
      }
    },
    requestResponse() {
      if (!this.userInfo || this.userInfo === null) {
        this.$store.dispatch('setSignInRedirectUrl', location.pathname)
        // this.$router.push({ name: 'SignIn' })
        this.guestInActionType = 'request'
        this.guestInVisible = true
      } else if (this.currentMt.isPublic) {
        if (this.currentMt.isEnded) {
          // notify(this, 'Error', this.$t('notiEndedMeeting'), 'error')
          const content = {
            component: Toast,
            props: {
              msg: this.$t('notiEndedMeeting'),
              // submsg: '',
            },
          }
          this.$toast.error(content)
        }
        // Free Type 일 경우 video upload 30개 이상인지 체크
        else if (this.checkAvailableClip) this.requestVisible = true
        // 업그레이드 팝업 호출
        else this.upgradeVisible = true
      } else {
        let isJoinedWorkspaceFist = false

        if (this.userWsList && this.userWsList !== null && this.selectedWsInfo && this.selectedWsInfo !== null) {
          let workspace = this.userWsList.find((workspace) => workspace.wsId === this.selectedWsInfo.wsId)
          if (!workspace || workspace === null) isJoinedWorkspaceFist = true
        } else isJoinedWorkspaceFist = true
        // if (this.followUpExsitContents !== undefined && this.followUpExsitContents !== null)
        //   notify(this, 'Error', this.followUpExsitContents, 'error')
        if (isJoinedWorkspaceFist) {
          // notify(this, 'Error', this.$t('joinTheWorkspaceFirstMsg'), 'error')

          const content = {
            component: Toast,
            props: {
              msg: this.$t('joinTheWorkspaceFirstMsg'),
              // submsg: '',
            },
          }
          this.$toast.error(content)
        } else {
          if (this.currentMt.isEnded) {
            // notify(this, 'Error', this.$t('notiEndedMeeting'), 'error')

            const content = {
              component: Toast,
              props: {
                msg: this.$t('notiEndedMeeting'),
                // submsg: '',
              },
            }
            this.$toast.error(content)
          }
          // Free Type 일 경우 video upload 30개 이상인지 체크
          else if (this.checkAvailableClip) this.requestVisible = true
          // 업그레이드 팝업 호출
          else this.upgradeVisible = true
        }
      }
    },
    finishRequestDialog() {
      this.requestVisible = false
      // this.$emit('refreshData')
    },
  },
  computed: {
    ...mapGetters([
      'uploadVideoInfo',
      'totalSectionList',
      'userInfo',
      'currentMt',
      'userWsList',
      'selectedWsInfo',
      'wsClipCnt',
    ]),
    computedWsClipCnt() {
      return this.wsClipCnt ?? {}
    },
    gridStyle() {
      return {
        'grid-template-columns': this.grid ? 'repeat(auto-fit, ' + this.grid + ')' : 'repeat(auto-fit, 33%)',
        width: this.width ? this.width : '500px',
      }
    },
    checkAvailableClip() {
      let isAvailableClip = true
      if (
        (this.userInfo &&
          (!this.computedWsClipCnt['planType'] || this.computedWsClipCnt['planType'] !== 'Plus') &&
          this.computedWsClipCnt['wsClipDuration'] >= this.computedWsClipCnt['freePlanWsClipDurationLimit']) ||
        (this.type == 'upload' && this.computedWsClipCnt['planType'] !== 'Plus')
      ) {
        isAvailableClip = false
      }
      return isAvailableClip
    },
    sectionList() {
      if (this.totalSectionList !== undefined && this.totalSectionList !== null && this.totalSectionList.length > 0) {
        return this.totalSectionList
      }
      return []
    },
  },
}
</script>

<style scoped>
.container {
  position: relative;
  width: 330px;
  height: 100px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.mdi-record-circle.mdi::before {
  font-size: 35px;
  color: #ff575f;
}
.mdi-record-circle {
  margin-top: -7px;
  margin-bottom: -9px;
}
.container-large-btn {
  border-radius: 15px !important;
  background: #0f2129;
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.container-btns {
  display: flex;
  max-width: 400px;
}
.container-btns.main-btns {
  max-width: 200px !important;
  border-radius: 5px;
}
.container-btns.sub-btns {
  position: absolute;
  width: 100%;
  top: 100px;
}
.container-btns.sub-btns >>> .material-icons-round {
  font-size: 20px;
  margin-bottom: 3px;
}
@media (max-width: 850px) {
  .container-btns {
    width: 95% !important;
    justify-content: space-evenly !important;
  }
}
.container-btn {
  background: rgb(22, 29, 33);
  cursor: pointer;
  height: 40px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  transition: all 0.3s;
}
.container-btn.expand {
  display: flex;
  flex-direction: column;
  height: 70px;
  border-radius: 5px !important;
}
.container-btn:hover {
  background: #071014;
  transition: all 0.3s;
}
@media (max-width: 1263px) {
  .container-btn {
    max-height: 80px;
    margin: 5px;
  }
}
@media (max-width: 959px) {
  .container-btn {
    width: 90%;
    margin: 5px;
  }
  .container-btn .empty_content_title {
    font-size: 11px;
  }
  .container-btn img {
    width: 20px;
  }
  .container-btn .mdi-record-circle::before {
    font-size: 28px;
  }
}
.v-icon.normal-icon {
  color: white;
  font-size: 1.8rem;
}

.v-icon.small-icon {
  color: white;
  font-size: 1.2rem;
}
.v-icon.record-icon {
  color: #ff575f;
  font-size: 2.2rem;
}
.material-icons-round {
  display: inline-block;
  color: #ccc;
  font-size: 35px;
  cursor: pointer;
}
.material-icons-round.red-icon {
  color: #ff464f;
}
span.empty_content_title {
  display: inline-block;
  white-space: nowrap;
  font-size: 11px;
  font-weight: 400;
  color: #aaa;
  transition: all 0.3s;
}
.container-btn.main-btn {
  border-radius: 5px;
  border: 1px solid #40dc9d;
}
span.empty_content_title.main-btn {
  font-size: 14px;
  font-weight: 500;
  color: #40dc9d;
}
.container-btn:hover >>> .material-icons-round {
  color: #eee;
  transition: all 0.3s;
}
.container-btn:hover >>> .material-icons-round.red-icon {
  color: #ff131e;
  transition: all 0.3s;
}
.container-btn:hover >>> span.empty_content_title {
  color: #eee;
  transition: all 0.3s;
}
@media (max-width: 1263px) {
  .material-icons-round {
    font-size: 25px;
  }
  span.empty_content_title {
    display: block;
    width: 100%;
    font-size: 12px;
    font-weight: 400;
    white-space: normal;
    margin-top: 5px;
  }
}
.slide-fade-enter-active {
  transition: all 0.3s cubic-bezier(1, 0.8, 0.5, 1);
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-10px);
  opacity: 0;
}
.slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-10px);
  opacity: 0;
}
.text-show-more {
  cursor: pointer;
}
.text-show-more span {
  font-size: 13px;
  color: #96a7af;
  text-decoration: underline;
}
.text-show-more:hover span {
  color: #b8c7ce;
}
</style>
